exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "blockquote,body,canvas,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,input,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}body{background:#000;width:100%;height:100%;margin:0 auto}html{//min-width:480px;//min-height:320px}body{margin:0;padding:0;overflow:hidden;font-family:Tahoma,Geneva,sans-serif;font-size:12px;color:#222;background:##F7F0F0}.hidden{display:none}canvas{display:block;margin:0 auto;background:#fff;width:320px;height:480px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/ml.css
// module id = 13
// module chunks = 0